//ClassicEditor = require( '@ckeditor/ckeditor5-31.1.0-t1hkzhmo74ei');
ClassicEditor = require( '@ckeditor/ckeditor5-31.1.0-k7kg3g5bgk28');
ClassicEditor.editorConfig = function( config ) {
    config.allowedContent= true
};
/*
Список для CKEditor https://ckeditor.com/ckeditor-5/online-builder/:
Alignment
Base64 upload adapter
Block quote
Bold
Find and replace
Font background color
Font color
Font family
Font size
General HTML Support
Heading
Highlight
Horizontal line
HTML embed
Image
Image caption
Image insert
Image resize
Image style
Image toolbar
Image upload
Indent
Italic
Link
List
List style
Media embed
Media embed toolbar
Paste from Office
Remove format
Source editing
Special characters
Special characters currency
Strikethrough
Table
Table caption
Table cell properties
Table properties
Table toolbar
Text transformation
Underline
*/
